<ng-container *ngIf="node$ | async as node">
  <ng-container *ngIf="styleClass$ | async as styleClass">
    <jaga-acc-nav-ui [node]="node" [ngClass]="styleClass"></jaga-acc-nav-ui>
  </ng-container>
</ng-container>
